class ProductRecommendations extends HTMLElement {
  static observedAttributes = ["product-id"];

  constructor() {
    super();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    // Assume url and section-id are static
    if (name === "product-id") {
      this._load();
    }
  }

  _load() {
    const url = this.getAttribute("url");
    const productId = this.getAttribute("product-id");
    const sectionId = this.getAttribute("section-id");
    const intent = this.getAttribute("intent") || "related";

    window
      .fetch(
        `${url}?product_id=${productId}&section_id=${sectionId}&intent=${intent}`,
      )
      .then((response) => response.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, "text/html");

        const recommendations = doc.querySelector("[data-recommendations]");

        if (!recommendations) {
          this.removeIfEmpty.remove();
          return;
        }

        const recommendationsFragment = document
          .createRange()
          .createContextualFragment(
            doc.querySelector("[data-recommendations]").outerHTML,
          );

        [...this.children].forEach((child) => child.remove());
        this.append(recommendationsFragment);
      });
  }

  get removeIfEmpty() {
    const selector = this.getAttribute("remove-if-empty");

    if (!selector) return this;

    return this.closest(selector);
  }
}

if (!customElements.get("product-recommendations")) {
  customElements.define("product-recommendations", ProductRecommendations);
}
